import type { ComponentType, SVGProps } from "react";

/**
 * Nucleo glyph override registry — keyed by the same kebab-case `name` the
 * `<Icon>` atom takes. Empty until licensed Nucleo SVGs are exported and
 * dropped into `./nucleo/` (see ./nucleo/README.md and
 * docs/design-language/PRD.md §10.3).
 *
 * The `<Icon>` atom resolves `name` Nucleo-first, then falls back to the
 * lucide glyph at 1px (the bridge). Adding an entry here upgrades that glyph
 * everywhere it is used, with no call-site change. Example, once a SVG lands:
 *
 *   import SearchNucleo from "./nucleo/search";
 *   export const NUCLEO_REGISTRY = { search: SearchNucleo };
 */
export const NUCLEO_REGISTRY: Record<
  string,
  ComponentType<SVGProps<SVGSVGElement>>
> = {};
